import { toPng } from 'html-to-image';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { credentialPdfBlob } from './credential-pdf';

async function captureSheetPng(node: HTMLElement): Promise<string> {
  return toPng(node, {
    cacheBust: true,
    pixelRatio: 3,
    backgroundColor: '#ffffff',
  });
}

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export function DownloadAllButton({ fallbackPrefix }: { fallbackPrefix: string }) {
  const [pending, setPending] = useState(false);
  const [progress, setProgress] = useState<{ done: number; total: number }>({
    done: 0,
    total: 0,
  });

  const handleDownloadAll = async () => {
    const sheets = Array.from(
      document.querySelectorAll<HTMLElement>('[data-pdf-page]'),
    );
    if (sheets.length === 0) {
      alert('No sheets found.');
      return;
    }

    setPending(true);
    setProgress({ done: 0, total: sheets.length });

    try {
      for (let i = 0; i < sheets.length; i++) {
        const node = sheets[i];
        const exportName =
          node.getAttribute('data-pdf-name') ?? `${fallbackPrefix}${i + 1}`;
        const png = await captureSheetPng(node);
        const blob = await credentialPdfBlob(png);
        downloadBlob(blob, `${exportName}.pdf`);
        setProgress({ done: i + 1, total: sheets.length });
        // Give the browser a beat between downloads to avoid being blocked.
        await sleep(400);
      }
    } catch (err) {
      console.error('Download all failed', err);
      alert('Download all failed. Check console.');
    } finally {
      setPending(false);
    }
  };

  return (
    <Button onClick={handleDownloadAll} disabled={pending}>
      {pending
        ? `Downloading ${progress.done}/${progress.total}…`
        : 'Download all PDFs'}
    </Button>
  );
}
